export let outlookDataFileFmt = "s8KWfd";
export default {outlookDataFileFmt};